import api from "@/services/axios.js";
import {
  MarkVerificationStagesAsPrintedRequest,
  MarkVerificationStagesAsPrintedRequestPayload,
} from "../../types.ts";
import { searchHandler } from "../../lib/helpers.ts";

export const markVerificationStagesAsPrinted = (
  data: MarkVerificationStagesAsPrintedRequest,
) => {
  const payload: MarkVerificationStagesAsPrintedRequestPayload = {};

  if (data.selectingAll) {
    payload.searchVerificationsRequestViewModel = searchHandler(
      data.searchValues,
    );
  } else {
    payload.verificationStaesIds = data.verificationStaesIds;
  }

  return api.put(
    "/api/AdminVerification/mark-verification-stages-as-printed",
    payload,
  );
};
